//-----[各種条件の変更時]
$(".simulator_left select").change(function (e) {
  setMarriageRingLeftImage();
});
$(".simulator_right select").change(function (e) {
  setMarriageRingRightImage();
});

//初期表示時に素材（combi#02）を非表示
$(".simulator_left .select_list dt:nth-child(5), .simulator_left .select_list dd:nth-child(6)").addClass("hidden");
$(".simulator_left .select_material2_left").prop("disabled", true);
$(".simulator_right .select_list dt:nth-child(5), .simulator_right .select_list dd:nth-child(6)").addClass("hidden");
$(".simulator_right .select_material2_right").prop("disabled", true);

//-----[デザイン変更時]
//-----[左のシミュレーター]
$(".select_design_left").change(function (e) {
  var no = parseInt(e.currentTarget.selectedIndex);
  //-----「combi#01」の時には「素材（通常）」を非表示
  if (no === 3) {
    $(".simulator_left .select_list dt:nth-child(3), .simulator_left .select_list dd:nth-child(4)").addClass("hidden");
    $(".simulator_left .select_material_left").prop("disabled", true);
  } else {
    $(".simulator_left .select_list dt:nth-child(3), .simulator_left .select_list dd:nth-child(4)").removeClass("hidden");
    $(".simulator_left .select_material_left").prop("disabled", false);
  }

  //-----「combi#02」の時には「ダイヤ留め」を非表示
  if (no === 4) {
    $(".simulator_left .select_list dt:nth-child(11), .simulator_left .select_list dd:nth-child(12)").addClass("hidden");
    $(".simulator_left .select_diamond_left").prop("disabled", true);
    $(".simulator_left .select_diamond_left").val(0);
  } else {
    $(".simulator_left .select_list dt:nth-child(11), .simulator_left .select_list dd:nth-child(12)").removeClass("hidden");
    $(".simulator_left .select_diamond_left").prop("disabled", false);
  }

  //-----「combi#02」の時には「素材（通常）」を非表示にし、「素材（combi#02）」を表示
  if (no === 4) {
    // 素材（通常）を非表示
    $(".simulator_left .select_list dt:nth-child(3), .simulator_left .select_list dd:nth-child(4)").addClass("hidden");
    $(".simulator_left .select_material_left").prop("disabled", true);

    // 素材（combi#02）を表示
    $(".simulator_left .select_list dt:nth-child(5), .simulator_left .select_list dd:nth-child(6)").removeClass("hidden");
    $(".simulator_left .select_material2_left").prop("disabled", false);
  } else {
    //combi#01じゃなければ
    if (no !== 3) {
    // 素材（通常）を表示
    $(".simulator_left .select_list dt:nth-child(3), .simulator_left .select_list dd:nth-child(4)").removeClass("hidden");
    $(".simulator_left .select_material_left").prop("disabled", false);
    }

    // 素材（combi#02）を非表示
    $(".simulator_left .select_list dt:nth-child(5), .simulator_left .select_list dd:nth-child(6)").addClass("hidden");
    $(".simulator_left .select_material2_left").prop("disabled", true);
  }
});
//-----[右のシミュレーター]
$(".select_design_right").change(function (e) {
  var no = parseInt(e.currentTarget.selectedIndex);
  //-----「combi#01」の時には「素材」を非表示
  if (no === 3) {
    $(".simulator_right .select_list dt:nth-child(3), .simulator_right .select_list dd:nth-child(4)").addClass("hidden");
    $(".simulator_right .select_material_right").prop("disabled", true);
  } else {
    $(".simulator_right .select_list dt:nth-child(3), .simulator_right .select_list dd:nth-child(4)").removeClass("hidden");
    $(".simulator_right .select_material_right").prop("disabled", false);
  }

  //-----「combi#02」の時には「ダイヤ留め」を非表示
  if (no === 4) {
    $(".simulator_right .select_list dt:nth-child(11), .simulator_right .select_list dd:nth-child(12)").addClass("hidden");
    $(".simulator_right .select_diamond_right").prop("disabled", true);
  } else {
    $(".simulator_right .select_list dt:nth-child(11), .simulator_right .select_list dd:nth-child(12)").removeClass("hidden");
    $(".simulator_right .select_diamond_right").prop("disabled", false);
  }

  //-----「combi#02」の時には「素材（通常）」を非表示にし、「素材（combi#02）」を表示
  if (no === 4) {
    // 素材（通常）を非表示
    $(".simulator_right .select_list dt:nth-child(3), .simulator_right .select_list dd:nth-child(4)").addClass("hidden");
    $(".simulator_right .select_material_right").prop("disabled", true);

    // 素材（combi#02）を表示
    $(".simulator_right .select_list dt:nth-child(5), .simulator_right .select_list dd:nth-child(6)").removeClass("hidden");
    $(".simulator_right .select_material2_right").prop("disabled", false);
  } else {
    //combi#01じゃなければ
    if (no !== 3) {
    // 素材（通常）を表示
    $(".simulator_right .select_list dt:nth-child(3), .simulator_right .select_list dd:nth-child(4)").removeClass("hidden");
    $(".simulator_right .select_material_right").prop("disabled", false);
    }

    // 素材（combi#02）を非表示
    $(".simulator_right .select_list dt:nth-child(5), .simulator_right .select_list dd:nth-child(6)").addClass("hidden");
    $(".simulator_right .select_material2_right").prop("disabled", true);
  }
});


/*----------------------------
	 選択したマリアージュリングの画像変更
	----------------------------*/
  function setMarriageRingLeftImage() {
    //-----[左画像の変更]
    var val1 = $(".select_design_left").val();
    var val2 = $(".select_width_left").val();
    var val3 = $(".select_material_left").val();
    var val3_2 = $(".select_material2_left").val();
    var val4 = $(".select_finish_left").val();
    var val5 = $(".select_diamond_left").val();

    //-----「combi#01」の時
    if (val1 === "4") {
      //-----「素材」を非表示にしているので、画像表示のために0を設定
      val3 = 0;
    }

    //-----「combi#02」の時
    if (val1 === "5") {
      //-----「ダイヤ留め」を非表示にしているので、画像表示のために0を設定
      val5 = 0;

      //-----「素材（通常）」の代わりに「素材（combi#02）」を設定
      val3 = val3_2;
    }

    var file =
      val1 + "_" + val2 + "_" + val3 + "_" + val4 + "_" + val5 + ".jpg";

    var defaultImageLeft = '//cobaco.shop/cdn/shop/t/7/assets/simulate_bridal_ring_1_n_1_1_0.jpg?v=89532371068085470571695650329';
    var changeImageLeft = defaultImageLeft.replace('simulate_bridal_ring_1_n_1_1_0.jpg', 'simulate_bridal_ring_' + file);
    $(".left_image").attr("src", changeImageLeft);

    gsap.fromTo(
      ".simulator_left .mask",
      1.2,
      { borderColor: "#eeeeee" },
      { borderColor: "#ffffff", ease: Sine.easeInOut }
    );

    // 金額
    var item_price = 0;
    var select_material = 0;
    var select_material2 = 0;
    var select_finish = 0;
    var option_price = 0;
    var select_diamond = 0;
    
    if (val2 == "n") {
      item_price = $(".select_design_left option:selected").data("price_n");
      select_diamond = $(".select_diamond_left option:selected").data("price_n");
      // console.log("narrow");
    } else if(val2 == "r") {
      item_price = $(".select_design_left option:selected").data("price_r");
      select_diamond = $(".select_diamond_left option:selected").data("price_r");
      // console.log("regular");
    } else if(val2 == "w") {
      item_price = $(".select_design_left option:selected").data("price_w");
      select_diamond = $(".select_diamond_left option:selected").data("price_w");
      // console.log("wide");
    }
    select_material = $(".select_material_left option:selected").data("price");
    select_material2 = $(".select_material2_left option:selected").data("price");
    select_finish = $(".select_finish_left option:selected").data("price");

    //combi#01の場合、素材価格を0にする
    if($(".select_design_left option:selected").val() == 4){
      select_material = 0;
      // console.log('素材の価格を0に');
    }

    //combi#02の場合、ダイヤ留め価格を0にする
    if($(".select_design_left option:selected").val() == 5){
      select_diamond = 0;
      // console.log('ダイヤ留めの価格を0に');
    }

    option_price = select_material + select_material2 + select_finish + select_diamond;
    // console.log(item_price,select_material,select_material2,select_finish,select_diamond);

    //------[金額を差し替え]
    var total_price = item_price + option_price;
    total_price = String(total_price).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    $(".simulator_container .simulator_left .price .num").html(total_price);



    //------[ボタンのURLを差し替え]
    // 商品のハンドル
    var item_handle = null;
    if (val2 == "n") {
      item_handle = $(".select_design_left option:selected").data("handle_n");
    } else if(val2 == "r") {
      item_handle = $(".select_design_left option:selected").data("handle_r");
    } else if(val2 == "w") {
      item_handle = $(".select_design_left option:selected").data("handle_w");
    }

    // パラメータ
    var param = null;
    var material_param = 0;
    var finish_param = 0;
    var diamond_param = 0;

    material_param = $('.select_material_left').prop('selectedIndex');
    //-----「combi#02」の時
    if (val1 === "5") {
      material_param = $('.select_material2_left').prop('selectedIndex');
    }
    
    finish_param = $('.select_finish_left').prop('selectedIndex');
    diamond_param = $('.select_diamond_left').prop('selectedIndex');

    param = '?material=' + material_param + '&finish=' + finish_param + '&diamond=' + diamond_param;

    $(".simulator_container .simulator_left .btn1 a").attr("href", '/products/' + item_handle + param);
  }

  function setMarriageRingRightImage() {
    //-----[右画像の変更]
    var val1 = $(".select_design_right").val();
    var val2 = $(".select_width_right").val();
    var val3 = $(".select_material_right").val();
    var val3_2 = $(".select_material2_right").val();
    var val4 = $(".select_finish_right").val();
    var val5 = $(".select_diamond_right").val();

    //-----「combi#01」の時
    if (val1 === "4") {
      //-----「素材」を非表示にしているので、画像表示のために0を設定
      val3 = 0;
    }

    //-----「combi#02」の時
    if (val1 === "5") {
      //-----「ダイヤ留め」を非表示にしているので、画像表示のために0を設定
      val5 = 0;

      //-----「素材（通常）」の代わりに「素材（combi#02）」を設定
      val3 = val3_2;
    }

    var file = val1 + "_" + val2 + "_" + val3 + "_" + val4 + "_" + val5 + ".jpg";
    var defaultImageRight = '//cobaco.shop/cdn/shop/t/7/assets/simulate_bridal_ring_1_n_1_1_0.jpg?v=89532371068085470571695650329';
    var changeImageRight = defaultImageRight.replace('simulate_bridal_ring_1_n_1_1_0.jpg', 'simulate_bridal_ring_' + file);
    $(".right_image").attr("src", changeImageRight);

    gsap.fromTo(
      ".simulator_right .mask",
      1.2,
      { borderColor: "#eeeeee" },
      { borderColor: "#ffffff", ease: Sine.easeInOut }
    );

    // 金額
    var item_price = 0;
    var select_material = 0;
    var select_material2 = 0;
    var select_finish = 0;
    var option_price = 0;
    var select_diamond = 0;
    
    if (val2 == "n") {
      item_price = $(".select_design_right option:selected").data("price_n");
      select_diamond = $(".select_diamond_right option:selected").data("price_n");
      // console.log("narrow");
    } else if(val2 == "r") {
      item_price = $(".select_design_right option:selected").data("price_r");
      select_diamond = $(".select_diamond_right option:selected").data("price_r");
      // console.log("regular");
    } else if(val2 == "w") {
      item_price = $(".select_design_right option:selected").data("price_w");
      select_diamond = $(".select_diamond_right option:selected").data("price_w");
      // console.log("wide");
    }
    select_material = $(".select_material_right option:selected").data("price");
    select_material2 = $(".select_material2_right option:selected").data("price");
    select_finish = $(".select_finish_right option:selected").data("price");

    //combi#01の場合、素材価格を0にする
    if($(".select_design_right option:selected").val() == 4){
      select_material = 0;
      // console.log('素材の価格を0に');
    }

    //combi#02の場合、ダイヤ留め価格を0にする
    if($(".select_design_right option:selected").val() == 5){
      select_diamond = 0;
      // console.log('ダイヤ留めの価格を0に');
    }

    option_price = select_material + select_material2 + select_finish + select_diamond;
    // console.log(item_price,select_material,select_material2,select_finish,select_diamond);

    //------[金額を差し替え]
    var total_price = item_price + option_price;
    total_price = String(total_price).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    $(".simulator_container .simulator_right .price .num").html(total_price);


        //------[ボタンのURLを差し替え]
    // 商品のハンドル
    var item_handle = null;
    if (val2 == "n") {
      item_handle = $(".select_design_right option:selected").data("handle_n");
    } else if(val2 == "r") {
      item_handle = $(".select_design_right option:selected").data("handle_r");
    } else if(val2 == "w") {
      item_handle = $(".select_design_right option:selected").data("handle_w");
    }

    // パラメータ
    var param = null;
    var material_param = 0;
    var finish_param = 0;
    var diamond_param = 0;

    material_param = $('.select_material_right').prop('selectedIndex');
    //-----「combi#02」の時
    if (val1 === "5") {
      material_param = $('.select_material2_right').prop('selectedIndex');
    }
    
    finish_param = $('.select_finish_right').prop('selectedIndex');
    diamond_param = $('.select_diamond_right').prop('selectedIndex');

    param = '?material=' + material_param + '&finish=' + finish_param + '&diamond=' + diamond_param;

    $(".simulator_container .simulator_right .btn1 a").attr("href", '/products/' + item_handle + param);
  }